// removed by extract-text-webpack-plugin
module.exports = {"Chat":"_3mfHhMeVnf_O5mNlREVOO7","Header":"_21e8dBhmt7FopqxSst433O","Body":"_2-HUEMXIqHm00AthGu3jOl","Users":"_23MVKWSm1FBj8d9CngyJPZ","Footer":"_1pTfC9SI0bLPo6C6fndtQ7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Chat/Chat.css
// module id = 230
// module chunks = 0